import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL;

export const createBlog = async (formData) => {
  try {
    const config = {
      headers: {
        'Content-Type': 'multipart/form-data',
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
      }
    };

    const response = await axios.post(`${API_URL}/blogposts/create/`, formData, config);
    return response.data;
  } catch (error) {
    console.error("The blog post could not be created: ", error);
    throw error;
  }
};